export default __webpack_public_path__ + "static/media/bike.9ad52d6a.svg";